import { gql } from '@apollo/client'
import { GENERATION_BASIS_VIEW_FIELDS } from '@/graphql/generation-basis-queries'

export const GET_AUDIENCE_BUILDER_ENABLED = gql`
    query AudienceBuilderEnabled($campaignId: String!) {
        AudienceHypothesis {
            audienceBuilderEnabled(campaignId: $campaignId)
        }
    }
`

export const GENERATE_AUDIENCE_HYPOTHESES = gql`
    mutation GenerateAudienceHypotheses(
        $campaignId: String!
        $publisherId: String!
        $objective: CampaignObjective!
        $location: LocationTargeting!
        $acquisitionBudget: Float!
        $requestedPersonas: Int
        $regenerate: Boolean
        $basis: GenerationBasisInput
    ) {
        generateAudienceHypotheses(
            campaignId: $campaignId
            publisherId: $publisherId
            objective: $objective
            location: $location
            acquisitionBudget: $acquisitionBudget
            requestedPersonas: $requestedPersonas
            regenerate: $regenerate
            basis: $basis
        ) {
            hypothesis_set_id
            status
            reason
            cached
            discarded_persona_count
            plan {
                persona_count
                recommended_persona_count
                ad_set_count
                reason
                warnings
                required_per_ad_set
                budget_per_ad_set
                personas_allowed
                mode
            }
            hypotheses {
                id
                kind
                label
                audience_id
                audience_mode
                status
                intent
                rationale
                problem
                outcome
                interests {
                    id
                    name
                }
                targeting_options {
                    option_class
                    id
                    name
                }
                estimated_reach_lower
                estimated_reach_upper
                discarded_term_count
                unavailable_term_count
                validated_at
                recommended
                basis {
                    ${GENERATION_BASIS_VIEW_FIELDS}
                }
            }
        }
    }
`

export const GET_AUDIENCE_HYPOTHESIS_LABELS = gql`
    query AudienceHypothesisLabels($campaignId: String!, $ids: [String!]!) {
        AudienceHypothesis {
            audienceHypotheses(campaignId: $campaignId, ids: $ids) {
                id
                kind
                label
                audience_mode
                targeting_options {
                    option_class
                    id
                    name
                }
            }
        }
    }
`
